<template>
  <span v-if="code">{{ country.name }}</span>
  <span v-else>n/a</span>
</template>

<script>
import countries from './countries'

export default {
  name: 'country',
  props: {
    code: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      country: {},
    }
  },
  created () {
    this.country = countries.find(c => c.alpha3 === this.code.toLowerCase())
  },
}
</script>

<style scoped>

</style>
